import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import * as firebase from 'firebase/app';
import { Router } from '@angular/router';
import { AngularFirestore } from 'angularfire2/firestore';
import { ApiService } from '../api/api.service';
const identifier = "token";

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    arr: any[];
    currencyTemp: any;
    countryCodeTemp: any;
    flag: boolean = false
    // role: any;
    flagSuccess: boolean = false;

    constructor(
        public database: AngularFireDatabase,
        private angularAuth: AngularFireAuth,
        private router: Router,
        public db: AngularFirestore,
        public api: ApiService,

    ) {
        this.setUp();
    }

    token: string = this.getTokenFromLocalStorage();
    countryCode: string = this.getCountryFromLocalStorage();
    currency: string = this.getCurrencyFromLocalStorage();
    role: string = this.getRoleFromLocalStorage();

    setUp() {
        this.token = this.getTokenFromLocalStorage();
        this.countryCode = this.getCountryFromLocalStorage();
        this.currency = this.getCurrencyFromLocalStorage();

        this.angularAuth.authState.subscribe((firebaseUser) => {
            if (firebaseUser) {
                localStorage.setItem('countryCode', 'SV');
                localStorage.setItem('currency', '$');
                localStorage.setItem('role', '0');
                localStorage.setItem(identifier, firebaseUser.uid);
                this.token = firebaseUser.uid;
                this.countryCode = 'SV';
                this.currency = '$';
            } else {
                localStorage.removeItem(identifier)
                this.token = null;
            }
        })
    }


    getTokenFromLocalStorage(): string {
        return localStorage.getItem(identifier)
    }

    getCountryFromLocalStorage(): string {
        return localStorage.getItem('countryCode')
    }

    getRoleFromLocalStorage(): string {
        return localStorage.getItem('role')
    }

    getCurrencyFromLocalStorage() {
        return localStorage.getItem('currency')
    }

    login(logindata) {
        return new Promise((resolve, reject) => {
            this.angularAuth.auth.signInWithEmailAndPassword(logindata.email, logindata.password).then((data) => {
                const uid = data.user ? data.user.uid : null;
                localStorage.setItem('countryCode', 'SV');
                localStorage.setItem('currency', '$');
                localStorage.setItem('role', '0');
                if (uid) {
                    localStorage.setItem(identifier, uid);
                    this.token = uid;
                }
                resolve();
            }, (err) => {
                reject(err);
            });
        });
    }

    validateAccount(logindata) {
        return new Promise(async resolve => {

            this.token = '';
            this.countryCode = '';
            this.currency = '';

            this.angularAuth.authState.subscribe((firebaseUser) => {
                if (firebaseUser) {

                    localStorage.setItem(identifier, firebaseUser.uid);
                    this.token = firebaseUser.uid;

                    this.api.getAllDocuments('configurations')
                        .then(async (arr) => {
                            this.arr = arr;
                            console.log("this.arr")
                            console.log(this.arr)
                            console.log("typeof (this.arr)")
                            console.log(typeof (this.arr))
                            console.log("this.arr.length")
                            console.log(this.arr.length)
                            if (this.arr.length > 0 && this.flag == false) {
                                this.currencyTemp = ''
                                this.countryCodeTemp = ''
                                this.arr.forEach(async conf_response => {
                                    let doc = conf_response
                                    if (this.flag == false) {
                                        for (const property in doc) {
                                            if (property === 'currency') {
                                                this.currencyTemp = doc[property]
                                            }
                                            if (property === 'countryCode') {
                                                this.countryCodeTemp = doc[property]
                                            }
                                            if (property === 'users' && this.flag == false) {
                                                for (const property2 in doc[property]) {
                                                    console.log(doc[property][property2].email)
                                                    console.log(doc[property][property2].role)
                                                    console.log("doc[property][property2].email === logindata.email")
                                                    console.log(doc[property][property2].email === logindata.email)
                                                    if (doc[property][property2].email === logindata.email) {
                                                        this.flag = true
                                                        this.role = doc[property][property2].role
                                                        break
                                                    }
                                                }
                                            }
                                        }
                                    }
                                });
                            } else {
                                console.log("arr is Empty")
                                resolve("fracaso");
                            }
                            if (this.flag) {
                                console.log(this.flag, logindata.email, logindata.password)
                                // var result = await this.angularAuth.auth.signInWithEmailAndPassword(logindata.email, logindata.password).then((data) => {
                                this.flagSuccess = true
                                localStorage.setItem('countryCode', this.countryCodeTemp)
                                localStorage.setItem('currency', this.currencyTemp)
                                localStorage.setItem('role', this.role)
                                // console.log(data)
                                // }, (err) => {
                                //     this.flagSuccess = false
                                // })
                                if (this.flagSuccess) {
                                    resolve("exito");
                                } else {
                                    resolve("fracaso");
                                }
                            } else {
                                console.log("fin de ejecucions")
                                resolve("fracaso");
                            }
                        })
                } else {
                    localStorage.removeItem(identifier)
                    this.token = null;
                }

            })

        });
    }

    //pauso desarrollo para resolver situacion de Zona Horaria en DO
    // login(logindata) {
    //     return new Promise(async resolve => {
    //         this.db.collection('configurations')
    //             .get()
    //             .toPromise()
    //             .then(async (querySnapshot) => {
    //                 this.arr = [];
    //                 querySnapshot.forEach(doc => {
    //                     var obj = JSON.parse(JSON.stringify(doc.data()))
    //                     this.arr.push(obj);
    //                 });
    //                 console.log(this.arr)
    //                 console.log(typeof (this.arr))
    //                 console.log(this.arr.length)
    //                 if (this.arr.length > 0 && this.flag == false) {
    //                     this.currencyTemp = ''
    //                     this.countryCodeTemp = ''
    //                     this.arr.forEach(async conf_response => {
    //                         let doc = conf_response
    //                         if (this.flag == false) {
    //                             for (const property in doc) {
    //                                 if (property === 'currency') {
    //                                     this.currencyTemp = doc[property]
    //                                 }
    //                                 if (property === 'countryCode') {
    //                                     this.countryCodeTemp = doc[property]
    //                                 }
    //                                 if (property === 'users' && this.flag == false) {
    //                                     for (const property2 in doc[property]) {
    //                                         console.log(doc[property][property2].email)
    //                                         console.log(doc[property][property2].role)
    //                                         console.log(doc[property][property2].email === logindata.email)
    //                                         if (doc[property][property2].email === logindata.email) {
    //                                             this.flag = true
    //                                             this.role = doc[property][property2].role
    //                                             break
    //                                         }
    //                                     }
    //                                 }
    //                             }
    //                         }
    //                     });
    //                 } else {
    //                     console.log("arr is Empty")
    //                     resolve("fracaso");
    //                 }
    //                 if (this.flag) {
    //                     console.log(this.flag, logindata.email, logindata.password)
    //                     var result = await this.angularAuth.auth.signInWithEmailAndPassword(logindata.email, logindata.password).then((data) => {
    //                         this.flagSuccess = true
    //                         localStorage.setItem('countryCode', this.countryCodeTemp)
    //                         localStorage.setItem('currency', this.currencyTemp)
    //                         localStorage.setItem('role', this.role)
    //                         console.log(data)
    //                     }, (err) => {
    //                         this.flagSuccess = false
    //                     })
    //                     if (this.flagSuccess) {
    //                         resolve("exito");
    //                     } else {
    //                         resolve("fracaso");
    //                     }
    //                 } else {
    //                     console.log("fin de ejecucions")
    //                     resolve("fracaso");
    //                 }
    //             })
    //     });
    // }

    logOut() {
        return this.angularAuth.auth.signOut().then(() => {
            this.token = null;
            this.router.navigate(['login']);
        });
    }

    resetPassword(emailAddress) {
        let auth = firebase.auth();
        return new Promise((resolve, reject) => {
            auth.sendPasswordResetEmail(emailAddress).then(function () {
                resolve(true);
            }).catch(function (error) {
                reject(error);
            });
        });
    }

    getCurrentUser() {
        return firebase.auth().currentUser;
    }

    private generateUUID(): string {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }

}
